import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { teleport: { type: Boolean, default: false } }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden")
      if (this.teleportValue) {
        document.body.appendChild(this.menuTarget)
        this.bindTeleportedListeners()
      }
    } else {
      this.hide()
    }
  }

  bindTeleportedListeners() {
    this.cleanupTeleport()
    this.teleportListeners = []

    this.menuTarget.querySelectorAll("[data-dismiss]").forEach(btn => {
      const handler = (e) => { e.stopPropagation(); this.hide() }
      btn.addEventListener("click", handler)
      this.teleportListeners.push([btn, handler])
    })

    const backdrop = this.menuTarget
    const backdropHandler = (e) => { if (e.target === backdrop) this.hide() }
    backdrop.addEventListener("click", backdropHandler)
    this.teleportListeners.push([backdrop, backdropHandler])

    this.menuTarget.querySelectorAll("[data-action*='dropdown#stop']").forEach(el => {
      const handler = (e) => e.stopPropagation()
      el.addEventListener("click", handler)
      this.teleportListeners.push([el, handler])
    })
  }

  cleanupTeleport() {
    if (this.teleportListeners) {
      this.teleportListeners.forEach(([el, handler]) => el.removeEventListener("click", handler))
    }
    this.teleportListeners = []
  }

  close(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.contains(event.target)) {
      this.hide()
    }
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    if (this.teleportValue && this.menuTarget.parentElement === document.body) {
      this.element.appendChild(this.menuTarget)
    }
  }

  connect() {
    this.closeHandler = this.close.bind(this)
    this.escapeHandler = this.escape.bind(this)
    document.addEventListener("click", this.closeHandler)
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
    document.removeEventListener("keydown", this.escapeHandler)
    this.cleanupTeleport()
    if (this.teleportValue && this.menuTarget.parentElement === document.body) {
      this.element.appendChild(this.menuTarget)
    }
  }

  escape(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }

  stop(event) {
    event.stopPropagation()
  }

  intercept(event) {
    event.preventDefault()
    event.stopPropagation()
  }
}
